import React, { useContext } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../util/reactIntl';
import { ensureCurrentUser, ensureUser } from '../../../../util/data';
import { NamedLink } from '../../../../components';
import { IconEyeL } from '../../../../icons';
import ActionButton from './ActionButton';
import css from './SectionContact.css';
import { ListingPageContext } from '../../ListingPage';

export default ({
    loading,
    riderListing,
    isOwnListing,
    listingAuthor,
    currentListing,
    userIsCurrentUser,
    isAnonymousListing,
    setExternalListingModalOpen,
}) => {
    const { setInquiryModalOpen } = useContext(ListingPageContext);

    const { state: currentListingState } = currentListing.attributes;

    const ensuredUser = userIsCurrentUser
        ? ensureCurrentUser(listingAuthor)
        : ensureUser(listingAuthor);

    const { publicData: userPublicData } = ensuredUser.attributes.profile;

    const isClosed = currentListingState === 'closed';

    const actionButtonProps = {
        handleExternalListingContacting: () => setExternalListingModalOpen(true),
        handleListingContacting: () => setInquiryModalOpen(true),
        currentListing,
        loading,
        riderListing,
        className: css.contactButtonDesktop,
    };

    const equiryNotAllowed = isClosed || isOwnListing;
    const equiryNotAllowedId = () =>
        isClosed
            ? 'contactAuthorButtonListingClosed'
            : isOwnListing
            ? 'inquiryDisabledForOwnListings'
            : 'default';

    return (
        <div className={css.buttonContainer}>
            {/* Desktop */}
            {equiryNotAllowed && (
                <p className={classNames([css.desktopOnly, css.notAllowed])}>
                    <FormattedMessage id={`ListingPage.${equiryNotAllowedId()}`} />
                </p>
            )}
            <ActionButton {...actionButtonProps} />
            {isClosed ? null : (
                <footer className={css.contactButtonMobSection}>
                    {/* Mobile */}
                    {equiryNotAllowed && (
                        <p className={css.notAllowed}>
                            <FormattedMessage id={`ListingPage.${equiryNotAllowedId()}`} />
                        </p>
                    )}
                    <ActionButton {...actionButtonProps} className={css.contactButtonMobile} />
                </footer>
            )}

            {isAnonymousListing || !ensuredUser.id || isOwnListing ? null : (
                <NamedLink
                    className={css.linkButton}
                    name="ProfilePage"
                    params={{
                        id: ensuredUser.id.uuid,
                        userType: userPublicData.userType || 'rider',
                    }}
                >
                    <IconEyeL />
                    Profil ansehen
                </NamedLink>
            )}
        </div>
    );
};
